import { useState } from 'react';

export const useToggle = initialValue => {
  const [toggleValue, setToggleValue] = useState(initialValue);
  const toggle = value => setToggleValue(state => (typeof value === 'boolean' ? value : !state));

  return [toggleValue, toggle];
};
